export const APP_ID = 'saywhatt-app';
export const WRAPPER_ELEMENT_ID = 'saywhatt-outer-div';
